import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseControlValueAccessor } from 'rev-shared/util/BaseControlValueAccessor';

import { IBanner } from './BannerTypes';

import styles from './BannerEntry.Component.module.less';

@Component({
	selector: 'banner-entry',
	templateUrl: './BannerEntry.Component.html',
	providers: [{
		provide: NG_VALUE_ACCESSOR,
		useExisting: forwardRef(() => BannerEntryComponent),
		multi: true
	}],
	standalone: false
})
export class BannerEntryComponent extends BaseControlValueAccessor<IBanner> {
	@Input() public showToggleBtn = false;
	@Input() public showPreviewBtn = false;
	@Input() public showEditDeleteBtns = false;
	@Output() public editEntry: EventEmitter<any> = new EventEmitter();
	@Output() public updateEntry: EventEmitter<any> = new EventEmitter();
	@Output() public deleteEntry: EventEmitter<any> = new EventEmitter();
	public readonly styles = styles;

	public isListView: boolean = true;

	public onEnabledToggleClick(): void {
		this.updateEntry.emit();
	}

	public onEditClick(): void {
		this.editEntry.emit();
	}

	public onDeleteClick(): void {
		this.deleteEntry.emit();
	}

	public onPreviewClick(): void {
		window.open(this.value.link, '_blank');
	}

}
